import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import pillSrc from '@cover/wachstumstoppen/button.svg';

const Pill = styled.img.attrs(props => ({
	style: {
		top: `${Math.floor(Math.random()*(props.placement.max - props.placement.min + 1) + props.placement.min)}%`,
		left: `${Math.floor(Math.random()*(props.placement.max - props.placement.min + 1) + props.placement.min)}%`
	},
}))`
	position: absolute;
	width: 40%;
	opacity: 0;
`

const WachstumStoppen = ({ play }) => {
	const pills = useRef(false);

	const layers = [];
	for (let n = 0; n <= 200; n++) {
		layers.push(<Pill  key={`pill-${n}`} src={pillSrc} placement={{min: -100, max: 100}}/>)
	}

	useEffect(() => {
		anime({
			targets: pills.current.children,
			easing: 'easeInOutSine',
			autoplay: play,
			duration: 100,
			opacity: 1,
			loop: true,
			direction: 'alternate',
			delay: anime.stagger(50)
		});
	}, [play])
	return (
		<>
			<div ref={pills}>
				{ layers }
			</div>
		</>
	)
};

export default WachstumStoppen;